import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";
import MoreNews from "../../News/containers/MoreNews";
import MostReadRacing from "../../Common/containers/MostReadRacing";
import HorseRacingMostFollowed from "./HorseRacingMostFollowed";

export default class HorseRacingTipsCentre extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  render() {
    const { location } = this.props;

    return (
      <StandardPage sport="racing" title="Tips Centre" >
        <div className="main-layout-left-column ">
          <div className="main-layout-block last-desktop">
            <MoreNews location={location} />
          </div>
          <div id="left-most-followed" className="main-layout-block main-layout-hide-desktop">
            <HorseRacingMostFollowed location={location} plainTitle />
          </div>
          <div id="left-most-read" className="main-layout-block last-handheld main-layout-hide-desktop">
            <MostReadRacing location={location} plainTitle />
          </div>
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "bottomMpu", "ocWidget", "horseRacingMostFollowed"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingTipsCentre.js